import script from "./ModalSynchronization.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSynchronization.vue?vue&type=script&setup=true&lang=js"

import "./ModalSynchronization.vue?vue&type=style&index=0&id=730d296c&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-730d296c"]])

export default __exports__